// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__fYmzf","title":"AfterFrontImage_title__1T44o"};